import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import moment from "moment";
import decode from "jwt-decode";
import router from "../router";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({
  isCompression: false,
  encodingType: "rc4",
  encryptionSecret: "$$w0rd@123",
});
Vue.use(Vuex);
const vuexLocal = new createPersistedState({
  storage: {
    getItem: (key) => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: (key) => ls.remove(key),
  },
});
export default new Vuex.Store({
  state: {
    blackWindows: false,
    message: null,
    token: null,
    user: null,
    userQuery: null,
    nav: "PanelHome",
    _alert: {
      snackbar: false,
      text: null,
    },
    rol: null,
    rols: [],
    company: [],
    companyCombo: [],
    roadCombo: [],
    cycleCombo: [],
    zoneCombo: [],
    socialCombo: [],
    profileCombo: [],
    deviceCombo: [],
    userCombo: [],
    road: [],
    cycle: [],
    zone: [],
    socialGroup: [],
    timer: [],
    station: [],
    panel: [],
    integratorPanel: [],
    devices: [],
    notify: [],
    listDevices: null,
    chartData: [],
    chartDataYear: [],
    chartDataRange: [],
    chartDataSensorRange: [],
    chartDataSensorDay: [],
    chartDataSensorYear: [],
    chartDataSensorGeneral: [],
    users: [],
    profile: [],
    deviceQuery: null,
    takeDevices: [],
    nodeDevice: [],
    integrators: [],
    integratorQuery: [],
  },
  getters: {
    getBlackWindows: (state) => {
      return state.blackWindows;
    },
    getNav: (state) => {
      return state.nav;
    },
    getMessage: (state) => {
      return state.message;
    },
    isLogin: (state) => {
      return state.user;
    },
    getUser: (state) => {
      return state.userQuery;
    },
    getIntegratorPanel: (state) => {
      return state.integratorPanel;
    },
    getPanel: (state) => {
      return state.panel;
    },
    getNotify: (state) => {
      return state.notify;
    },
    getRolDevice: (state) => {
      if (state.rol != null) {
        let lector = state.rol._modules
          .map((item) => {
            if (item.nameModule == "Dispositivos" && item.checkModule == true) {
              return true;
            }
          })
          .filter((i) => i);
        return lector[0];
      }
    },
    getRol: (state) => {
      return state.rol;
    },
    getListRol: (state) => {
      return state.rols;
    },
    isRoad: (state) => {
      let isRoad = state.rol._modules
        .map((rol) => {
          if (rol.nameModule === "Ruta" && rol.checkModule === true) {
            return rol;
          }
        })
        .filter((rol) => {
          return rol;
        });
      return isRoad.length;
    },
    isCycle: (state) => {
      let isCycle = state.rol._modules
        .map((rol) => {
          if (rol.nameModule === "Ciclos" && rol.checkModule === true) {
            return rol;
          }
        })
        .filter((rol) => {
          return rol;
        });
      return isCycle.length;
    },
    isZone: (state) => {
      let isZone = state.rol._modules
        .map((rol) => {
          if (rol.nameModule === "Zona" && rol.checkModule === true) {
            return rol;
          }
        })
        .filter((rol) => {
          return rol;
        });
      return isZone.length;
    },
    isGroupSocial: (state) => {
      let isGroupSocial = state.rol._modules
        .map((rol) => {
          if (rol.nameModule === "Estrato" && rol.checkModule === true) {
            return rol;
          }
        })
        .filter((rol) => {
          return rol;
        });
      return isGroupSocial.length;
    },
    isPeriod: (state) => {
      let isPeriod = state.rol._modules
        .map((rol) => {
          if (rol.nameModule === "Periodo" && rol.checkModule === true) {
            return rol;
          }
        })
        .filter((rol) => {
          return rol;
        });
      return isPeriod.length;
    },
    isMaster: (state) => {
      let isMaster = state.rol._modules
        .map((rol) => {
          if (rol.nameModule === "Master" && rol.checkModule === true) {
            return rol;
          }
        })
        .filter((rol) => {
          return rol;
        });
      return isMaster.length;
    },
    getAlert: (state) => {
      return state._alert;
    },
    getCompanyCombo: (state) => {
      return state.companyCombo;
    },
    getListCompany: (state) => {
      return state.company;
    },
    getListCompanyActive: (state) => {
      let arrActive = state.company
        .map((item) => {
          if (item.activate == 1) {
            return item;
          }
        })
        .filter((i) => i);
      return arrActive;
    },
    getListRoad: (state) => {
      return state.road;
    },
    getListRoadActive: (state) => {
      let arrActive = state.road
        .map((item) => {
          if (item.activate == 1) {
            return item;
          }
        })
        .filter((i) => i);
      return arrActive;
    },
    getListCycle: (state) => {
      return state.cycle;
    },
    getListCycleActive: (state) => {
      let arrActive = state.cycle
        .map((item) => {
          if (item.activate == 1) {
            return item;
          }
        })
        .filter((i) => i);
      return arrActive;
    },
    getListZone: (state) => {
      return state.zone;
    },
    getListZoneActive: (state) => {
      let arrActive = state.zone
        .map((item) => {
          if (item.activate == 1) {
            return item;
          }
        })
        .filter((i) => i);
      return arrActive;
    },
    getListPeriod: (state) => {
      return state.period;
    },
    getListPeriodActive: (state) => {
      let arrActive = state.period
        .map((item) => {
          if (item.activate == 1) {
            return item;
          }
        })
        .filter((i) => i);
      return arrActive;
    },
    getListSocialGroup: (state) => {
      return state.socialGroup;
    },
    getListSocialGroupActive: (state) => {
      let arrActive = state.socialGroup
        .map((item) => {
          if (item.activate == 1) {
            return item;
          }
        })
        .filter((i) => i);
      return arrActive;
    },
    getTimerConfig: (state) => {
      return state.timer;
    },
    getListStation: (state) => {
      return state.station;
    },
    getListDevice: (state) => {
      return state.devices;
    },
    getListDeviceCustom: (state) => {
      return state.listDevices;
    },
    getDeviceTake: (state) => {
      return state.takeDevices;
    },
    getListDeviceSucess: (state) => {
      let items = state.takeDevices
        .map((el) => {
          return el.value;
        })
        .filter((el) => el);
      return items;
    },
    getFilterDeviceMap: (state) => {
      let arrelem = state.devices
        .map((item) => {
          if (item.latitude != 0 && item.longitude != 0) {
            item = {
              _id: item._id,
              idx: item.idx,
              nui: item.nui,
              profile: item.profile,
              latitude: item.latitude,
              longitude: item.longitude,
              address: item.address,
              switch: item.switch,
              serial: item.serial,
              subTypeService: item.subTypeService,
              company: item.company,
            };
            return item;
          }
        })
        .filter((i) => i);
      return arrelem;
    },
    getFilterDevice: (state) => {
      let arrelem = state.devices.map((item) => {
        item = {
          _id: item._id,
          idx: item.idx,
          nui: item.nui,
          serial: item.serial,
          city: item.city,
          subTypeService: item.subTypeService,
          company: item.company,
        };
        return item;
      });
      return arrelem;
    },
    getQueyDevice: (state) => {
      return state.deviceQuery;
    },
    getListIntegrator: (state) => {
      return state.integrators;
    },
    // getFilterIntegrator: (state) => {
    //   let arrelem = state.integrators
    //     .map((item) => {
    //       item = {
    //         _id: item._id,
    //         name: item.name,
    //         company: item.company._id,
    //         level: item.level,
    //       }
    //       return item
    //     })
    //     .filter((i) => i)
    //   return arrelem
    // },
    // getFilterIntegratorMap: (state) => {
    //   let arrelem = state.integrators
    //     .map((item) => {
    //       item = {
    //         _id: item._id,
    //         name: item.name,
    //         company: item.company._id,
    //         companyName: item.company.name,
    //         idx: item.device.idx,
    //         device: item.device._id,
    //         latitude: item.device.latitude,
    //         longitude: item.device.longitude,
    //         activate: item.activate,
    //         switch: item.device.switch,
    //         address: item.device.address,
    //       }
    //       return item
    //     })
    //     .filter((i) => i)
    //   return arrelem
    // },
    getQueyIntegrator: (state) => {
      return state.integratorQuery;
    },
    getQueyNode: (state) => {
      return state.nodeDevice;
    },
    getListUsers: (state) => {
      return state.users;
    },
    getListProfile: (state) => {
      return state.profile;
    },
    getFilterProfile: (state) => {
      let arrelem = state.profile.map((item) => {
        item = {
          _id: item._id,
          nuid: item.nuid,
          IDcard: item.IDcard,
          company: item.company,
        };
        return item;
      });
      return arrelem;
    },
    getNotifyDeviceNumber: (state) => {
      let array = state.devices;
      let arrNotify = [];
      if (array != null) {
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          element.historyDevice.forEach((item) => {
            if (item.check === true) {
              arrNotify.push({
                _id: item._id,
                device: element._id,
                idx: element.idx,
                serial: element.serial,
                register: item.register,
                action: item.action,
                date: item.date,
                check: item.check,
              });
            }
          });
        }
        return arrNotify.length;
      } else {
        return 0;
      }
    },
    getNotifyDevice: (state) => {
      let array = state.devices;
      let arrNotify = [];
      if (array != null) {
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          element.historyDevice.forEach((item) => {
            arrNotify.push({
              _id: item._id,
              idx: element.idx,
              device: element._id,
              serial: element.serial,
              register: item.register,
              action: item.action,
              date: item.date,
              check: item.check,
            });
          });
        }
        return arrNotify;
      } else {
        return [];
      }
    },
    getNotifyDeviceShowAlert: (state) => {
      let array = state.devices;
      let arrNotify = [];
      if (array != null) {
        for (let index = 0; index < array.length; index++) {
          const element = array[index];
          element.historyDevice.forEach((item) => {
            let dateArray = moment(item.date).format("YYYY-MM-DD");
            let nowDate = moment(new Date()).format("YYYY-MM-DD");
            if (item.check === true && dateArray >= nowDate) {
              arrNotify.push({
                _id: item._id,
                idx: element.idx,
                device: element._id,
                serial: element.serial,
                nui: element.nui,
                register: item.register,
                action: item.action,
                date: item.date,
                check: item.check,
              });
            }
          });
        }
        return arrNotify;
      } else {
        return [];
      }
    },
    getDataChartDay: (state) => {
      return state.chartData;
    },
    getDataChartYear: (state) => {
      return state.chartDataYear;
    },
    getChartDataSensorDay(state){
      return state.chartDataSensorDay
    },
    getChartDataSensorYear(state){
      return state.chartDataSensorYear
    },
    getChartDataSensorGeneral(state){
      return state.chartDataSensorGeneral
    },
    getChartDataSensorRange(state){
      return state.chartDataSensorRange
    },
    getDataChartRange: (state) => {
      return state.chartDataRange;
    },
  },
  mutations: {
    setClearDeviceQuery(state, val) {
      state.deviceQuery = val;
    },
    setBlackWindows(state, val) {
      state.blackWindows = val;
    },
    setClean(state) {
      state.blackWindows = false;
      state.message = null;
      state.user = null;
      state.userQuery = null;
      state.nav = "PanelHome";
      state.rol = null;
      state.rols = [];
      state.company = [];
      state.road = [];
      state.cycle = [];
      state.zone = [];
      state.socialGroup = [];
      state.timer = [];
      state.station = [];
      state.devices = [];
      state.notify = [];
      state.panel = [];
      state.integratorPanel = [];
      state.users = [];
      state.profile = [];
      state.deviceQuery = null;
      state.takeDevices = [];
      state.nodeDevice = [];
      state.integrators = [];
      state.integratorQuery = [];
    },
    setMessage(state, message) {
      state.message = message;
    },
    setToken(state, token) {
      state.token = token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setRol(state, rol) {
      state.rol = rol;
    },
    setRols(state, rol) {
      state.rols = rol;
    },
    setAlert(state, obj) {
      state._alert.snackbar = obj.snackbar;
      state._alert.text = obj.text;
    },
    setUserQuery(state, user) {
      state.userQuery = user;
    },
    setNotify(state, doc) {
      state.notify = doc;
    },
    setPanel(state, doc) {
      state.panel = doc;
    },
    setIntegratorPanel(state, doc) {
      state.integratorPanel = doc;
    },
    setCompanyCombo(state, doc) {
      state.companyCombo = doc;
    },
    setCompany(state, doc) {
      state.company = doc;
    },
    setRoad(state, doc) {
      state.road = doc;
    },
    setCycle(state, doc) {
      state.cycle = doc;
    },
    setZone(state, doc) {
      state.zone = doc;
    },
    setPeriod(state, doc) {
      state.period = doc;
    },
    setSocialGroup(state, doc) {
      state.socialGroup = doc;
    },
    setTimerConfig(state, doc) {
      state.timer = doc;
    },
    setStation(state, doc) {
      state.station = doc;
    },
    setDevice(state, doc) {
      state.devices = doc;
    },
    setDeviceCustom(state, doc) {
      state.listDevices = doc;
    },
    setDeviceTake(state, doc) {
      state.takeDevices = doc;
    },
    setDeviceQuery(state, doc) {
      state.deviceQuery = doc;
    },
    setDeviceNode(state, doc) {
      state.nodeDevice = doc;
    },
    setIntegrator(state, doc) {
      state.integrators = doc;
    },
    setIntegratorQuery(state, doc) {
      state.integratorQuery = doc;
    },
    setUsers(state, doc) {
      state.users = doc;
    },
    setProfile(state, doc) {
      state.profile = doc;
    },
    setNav(state, doc) {
      state.nav = doc;
    },
    setChartData(state, doc) {
      state.chartData = doc;
    },
    setChartDataYear(state, doc) {
      state.chartDataYear = doc;
    },
    setChartDataSensorDay(state,doc){
      state.chartDataSensorDay =doc
    },
    setChartDataSensorYear(state, doc){
      state.chartDataSensorYear = doc
    },
    setChartDataSensorGeneral(state,doc){
      state.chartDataSensorGeneral =doc
    },
    setChartDataSensorRange(state,doc){
      state.chartDataSensorRange =doc
    },
    setChartDataRange(state, doc) {
      state.chartDataRange = doc;
    },
  },
  actions: {
    actionNav({ commit }, obj) {
      commit("setNav", obj);
    },
    alertSnackbar({ commit }, obj) {
      commit("setAlert", obj);
    },
    saveToken({ commit }, token) {
      commit("setToken", token);
      commit("setUser", decode(token));
      localStorage.setItem("token", token);
    },
    autoLogin({ commit }) {
      const token = localStorage.getItem("token");
      if (!token) {
        return;
      }
      commit("setToken", token);
      commit("setUser", decode(token));
    },
    signOut({ commit }) {
      commit("setToken", null);
      commit("setUser", null);
      commit("setClean");
      localStorage.removeItem("token");
      router.push({
        path: "/",
      });
    },
    async tokenHasExpired() {
      let payloadToken = decode(this.state.token);
      let dateExpToken = new Date(payloadToken.exp * 1000);
      let dateNow = new Date();
      return dateNow >= dateExpToken;
    },
    async queryRol({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(
          `/roluser/query/${this.state.userQuery.rol}`,
          {
            headers: headerToken,
          }
        );
        let data = res.data;
        commit("setRol", data);
      } catch (error) {
        commit("setRol", null);
      }
    },
    async queryUser({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`/user/query/${this.state.user._id}`, {
          headers: headerToken,
        });
        let data = res.data;
        let elem = {
          name: data.name,
          email: data.email,
          company: data.company.name,
          companyID: data.company._id,
          rol: data.rol,
        };
        commit("setUserQuery", elem);
      } catch (error) {
        commit("setUserQuery", null);
      }
    },
    async queryUserDevices({ commit }, param) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(`/user/devices/${param}`, {
              headers: headerToken,
            })
            .then((res) => {
              resolve(res.data);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async QueryDevice({ commit }, param) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(`/device/query/${param}`, { headers: headerToken })
            .then((res) => {
              commit("setDeviceQuery", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error);
              reject(error);
            });
        });
      } catch (error) {
        commit("setDeviceQuery", null);
      }
    },
    async QueryDeviceNode({ commit }, param) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(`/device/querynode/${param.node}/${param.station}`, {
              headers: headerToken,
            })
            .then((res) => {
              commit("setDeviceNode", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error);
              reject(error);
            });
        });
      } catch (error) {
        commit("setDeviceNode", null);
      }
    },

    async listRol({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`roluser/panel`, { headers: headerToken });
        let data = res.data;
        commit("setRols", data);
      } catch (error) {
        commit("setRols", []);
      }
    },
    async addRol({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`roluser/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listRol");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateRol({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`roluser/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listRol");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateManiobrasUser({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`user/updateManiobrasUser`, dataForm, { headers: headerToken })
            .then((res) => {
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listProfile({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`profile/panel`, { headers: headerToken });
        let data = res.data;
        commit("setProfile", data);
      } catch (error) {
        commit("setProfile", []);
      }
    },
    async addProfile({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`profile/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listProfile");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateProfile({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`profile/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listProfile");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateUserProfile({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`user/updateuserprofile`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listUser");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateUserDevice({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`user/updateuserdevice`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listUser");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateUser({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`user/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listUser");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listUser({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`user/panel`, { headers: headerToken });
        let data = res.data;
        commit("setUsers", data);
      } catch (error) {
        commit("setUsers", []);
      }
    },
    async addUser({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`user/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listUser");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async addDeviceIntegrator({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`integrator/add/device`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listIntegrator");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async deleteDeviceIntegrator({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`integrator/delete/device`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listIntegrator");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async addIntegrator({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`integrator/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listIntegrator");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async QueryIntegrator({ commit }, param) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`/integrator/query/${param}`, {
          headers: headerToken,
        });
        let data = res.data;
        commit("setIntegratorQuery", data);
      } catch (error) {
        commit("setIntegratorQuery", null);
      }
    },
    async updateIntegrator({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`integrator/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listIntegrator");
              resolve(res.status);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listIntegrator({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`integrator/list`, { headers: headerToken });
        let data = res.data;
        commit("setIntegrator", data);
      } catch (error) {
        commit("setIntegrator", []);
      }
    },
    async exportIntegratorRange({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`integrator/exportrange`, dataForm, { headers: headerToken })
            .then((res) => {
              //dispatch('listIntegrator')
              resolve(res.data);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async exportIntegratorAll({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`integrator/exportall`, dataForm, { headers: headerToken })
            .then((res) => {
              //dispatch('listIntegrator')
              resolve(res.data);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async exportDeviceRangCom({ dispatch, commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`device/exportrangecom`, dataForm, {
              headers: headerToken,
            })
            .then((res) => {
              dispatch("listDevice");
              resolve(res.data);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async exportInvoice({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`device/exportinvoice`, dataForm, {
              headers: headerToken,
            })
            .then((res) => {
              resolve(res.data);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async exportRangeTakeRead({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`device/exportrangetake`, dataForm, {
              headers: headerToken,
            })
            .then((res) => {
              resolve(res.data);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async exportReportReads({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`device/exportreads`, dataForm, {
              headers: headerToken,
            })
            .then((res) => {
              resolve(res.data);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async exportClient({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`device/exportclient`, dataForm, {
              headers: headerToken,
            })
            .then((res) => {
              resolve(res.data);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async exportNotifications({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`notify/exportnotifications`, dataForm, {
              headers: headerToken,
            })
            .then((res) => {
              resolve(res.data);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    /*control grafica*/
    async deviceChartDay({ commit }, param) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(`device/chartday/${param._id}/${param.date}`, {
              headers: headerToken,
            })
            .then((res) => {
              resolve(res.data);
            })
            .catch((error) => {
              commit("setMessage", error.response.data);
              reject(error);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listDevice({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`device/list`, { headers: headerToken });
        let data = res.data;
        commit("setDevice", data);
      } catch (error) {
        commit("setDevice", []);
      }
    },
    async listDeviceCustom({ commit }, pagination) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(
              `device/listcustom?${pagination.page}&search=${pagination.search}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //dispatch("listDevice");
              commit("setDeviceCustom", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setDeviceCustom", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    /*Notificaciones*/
    async updateNotifyAll({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`notify/updateall`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("panelNotify");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateNotify({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`notify/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("panelNotify");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async panelNotify({ commit }) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(`notify/panel`, {
              headers: headerToken,
            })
            .then((res) => {
              //dispatch("listDevice");
              commit("setNotify", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setNotify", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    /*Panel de control*/
    async panelDevice({ commit }) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(`device/panel`, {
              headers: headerToken,
            })
            .then((res) => {
              console.log(res.data)
              //dispatch("listDevice");
              commit("setPanel", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setPanel", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async panelIntegrator({ commit }) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(`integrator/panel`, {
              headers: headerToken,
            })
            .then((res) => {
              //dispatch("listDevice");
              commit("setIntegratorPanel", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setIntegratorPanel", error.response.data);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    /* */
    // eslint-disable-next-line no-unused-vars
    async takeReadDevice({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`device/takereading`, dataForm, { headers: headerToken })
            .then((res) => {
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async takeReadingAll({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`device/takereadingall`, dataForm, { headers: headerToken })
            .then((res) => {
              commit("setDeviceTake", res.data.data);
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async addLimit({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`device/addlimit`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listDevice");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async deleteLimit({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`device/deletelimit`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listDevice");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateDevice({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`device/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listDevice");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },

    async ConfigDevice({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`device/updateConfig`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listDevice");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async addSchedule({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`device/addschedule`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listDevice");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async switchDevice({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`device/switch`, dataForm, {
              headers: headerToken,
            })
            .then((res) => {
              dispatch("listDevice");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async deleteSchedule({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`device/deleteschedule`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listDevice");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listStation({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`station/listpanel`, {
          headers: headerToken,
        });
        let data = res.data;
        commit("setStation", data);
      } catch (error) {
        commit("setStation", []);
      }
    },
    async addStation({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`station/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listStation");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateStation({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`station/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listStation");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listTimeConfig({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`timerconfig/list`, { headers: headerToken });
        let data = res.data;
        commit("setTimerConfig", data);
      } catch (error) {
        commit("setTimerConfig", []);
      }
    },
    async updateTimerConfig({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`timerconfig/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listTimeConfig");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listSocialGroup({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`socialgroup/panel`, {
          headers: headerToken,
        });
        let data = res.data;
        commit("setSocialGroup", data);
      } catch (error) {
        commit("setSocialGroup", []);
      }
    },
    async addSocialGroup({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`socialgroup/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listSocialGroup");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateSocialGroup({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`socialgroup/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listSocialGroup");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async addZone({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`zone/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listZone");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateZone({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`zone/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listZone");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listZone({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`zone/panel`, { headers: headerToken });
        let data = res.data;
        commit("setZone", data);
      } catch (error) {
        commit("setZone", []);
      }
    },
    async addPeriod({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`period/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listPeriod");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updatePeriod({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`period/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listPeriod");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async deletePeriod({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .delete(`period/delete`, { data: dataForm, headers: headerToken })
            .then((res) => {
              dispatch("listPeriod");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listPeriod({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`period/list`, { headers: headerToken });
        let data = res.data;
        commit("setPeriod", data);
      } catch (error) {
        commit("setPerido", []);
      }
    },
    async listCycle({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`cycle/panel`, { headers: headerToken });
        let data = res.data;
        commit("setCycle", data);
      } catch (error) {
        commit("setCycle", []);
      }
    },
    async addCycle({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`cycle/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listCycle");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateCycle({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`cycle/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listCycle");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listRoad({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`road/panel`, { headers: headerToken });
        let data = res.data;
        commit("setRoad", data);
      } catch (error) {
        commit("setRoad", []);
      }
    },
    async addRoad({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`road/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listRoad");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateRoad({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`road/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listRoad");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async companyCombo({ commit }) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(`company/list`, { headers: headerToken })
            .then((res) => {
              commit("setCompany", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async listCompany({ commit }) {
      try {
        let headerToken = { token: this.state.token };
        let res = await axios.get(`company/panel`, { headers: headerToken });
        let data = res.data;
        commit("setCompany", data);
      } catch (error) {
        commit("setCompany", []);
      }
    },
    async addCompany({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .post(`company/add`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listCompany");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async updateCompany({ dispatch }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .put(`company/update`, dataForm, { headers: headerToken })
            .then((res) => {
              dispatch("listCompany");
              resolve(res.status);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },

    async actionDataSensorDay({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          axios
            .get(`device/devicedata/${dataForm._id}/${dataForm.date}`)
            .then((res) => {
              commit("setChartDataSensorDay", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setChartDataSensorDay", null);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },

    async actionDataSensorYear({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          axios
            .get(`device/devicedataYear/${dataForm._id}/${dataForm.date}`)
            .then((res) => {
              commit("setChartDataSensorYear", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setChartDataSensorYear", null);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },

    async actionDataSensorGeneral({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          axios
            .get(`device/devicedataGeneral/${dataForm._id}/${dataForm.data}`)
            .then((res) => {
              commit("setChartDataSensorGeneral", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setChartDataSensorGeneral", null);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async actionDataSensorRange({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          axios
            .get(`device/devicedataRange/${dataForm._id}/${dataForm.date}`)
            .then((res) => {
              commit("setChartDataSensorRange", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setChartDataSensorRange", null);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    
    async actionDataChartDay({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(`/device/chartday/${dataForm._id}/${dataForm.date}`, {
              headers: headerToken,
            })
            .then((res) => {
              commit("setChartData", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setChartData", null);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async actionDataChartYear({ commit }, dataForm) {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(`/device/chartyear/${dataForm._id}/${dataForm.date}`, {
              headers: headerToken,
            })
            .then((res) => {
              commit("setChartDataYear", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setChartDataYear", null);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async actionDataChartRange({ commit }, dataForm) {
      try {
        console.log(dataForm.date.toString())
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.state.token };
          axios
            .get(
              `/device/chartrange/${dataForm._id}/${dataForm.date.toString()}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              commit("setChartDataRange", res.data);
              resolve(res.status);
            })
            .catch((error) => {
              commit("setChartDataRange", null);
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
  },
  modules: {},
  plugins: [vuexLocal],
});
